export default __webpack_public_path__ + "static/media/colocado-7-thumb.27090a1b.jpg";